<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/project/details/', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">Zum Projekt</a>
    </li>
  </ul>
</nav>

<main *ngIf="!!offers">
  <h2>Offer {{ projectId }}.0003.{{ offerId }}</h2>
  <p *ngIf="loading1">
    <span class="label label-light-blue">Angebot vom: {{ offers.offer_date | date:'dd.MM.yyyy'  }}</span>
    <span class="label label-light-blue">Summe (netto): {{ offerTotal | currency: 'EUR':'code':'1.2-2':'de'  }}</span>
    <span class="label {{ statusLabel }}">Status: {{ statusText }}
      <clr-dropdown [clrCloseMenuOnItemClick]="true">
        <button clrDropdownTrigger aria-label="Dropdown demo button">
            <cds-icon shape="angle" direction="down"></cds-icon>
        </button>
        <clr-dropdown-menu *clrIfOpen>
            <label class="dropdown-header" aria-hidden="true">Status ändern</label>
            <div class="dropdown-divider" role="separator" aria-hidden="true"></div>
            <div clrDropdownItem *ngFor="let item of statusButtons let i = index" (click)="changeOfferStatus(projectId, offerId, i)">{{ item.display }}</div>
        </clr-dropdown-menu>
      </clr-dropdown>
    </span>
  </p>

  <div class="spinner" *ngIf="!loading1">Loading data</div>
  <div class="clr-row" *ngIf="loading1">
    <div class="clr-col-lg-12 clr-col-md-12 clr-col-12">
      <div class="card">
        <div class="card-header">
          {{ offers.name_project }}
        </div>
        <div class="card-block">
          <div class="card-text">
            <clr-tabs>
              <clr-tab *ngIf="!!person">
                <button clrTabLink>Übersicht</button>
                <clr-tab-content clrTabContentId="content1" *clrIfActive="true">
                  <br>
                  <div class="clr-row">
                    <div class="clr-col-5">
                      <div class="clr-row">
                        <div class="clr-col-5">
                          Kunde
                        </div>
                        <div class="clr-col-1">
                          <cds-icon shape="note" [routerLink]="['/contact/details', companyId ]"></cds-icon>
                        </div>
                        <div class="clr-col-6">
                          {{ offers.company_name }}<br />{{ offers.street }}<br />{{ offers.postcode }} {{ offers.city }}
                          <span *ngIf="offers.country !== 'Deutschland'">{{ offers.country }}</span>
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-5">
                          Ansprechpartner beim Kunden
                        </div>
                        <div class="clr-col-1">
                          <cds-icon shape="note" [routerLink]="['/person/details', personId ]"></cds-icon>
                        </div>
                        <div class="clr-col-6">
                          {{ personSalutation }} {{ personFirstName }} {{ personLastName }}
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-5">
                          Projektnummer des Kunden:
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-6">
                          {{ offers.request_id }}
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-5">
                          Angebotsbedingungen:
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-6">
                          {{ offerCondition }}
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-5">
                          Zahlungsbedingungen:
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-6">
                          {{ paymentCondition }}
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-5">
                          Lieferung:
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-6">
                          {{ deliveryCondition }}
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-5">
                          Lieferzeit:
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-6">
                          {{ offers.delivery_remarks }}
                        </div>
                      </div>
                      <div *ngIf="offers.order_id" class="clr-row">
                        <div class="clr-col-5">
                          Bestellnummer des Kunden:
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-6">
                          {{ offers.order_id }}
                        </div>
                      </div>
                    </div>
                    <div class="clr-col-7">
                      <div class="clr-row">
                        <div class="clr-col-2">
                          Kommentare
                        </div>
                        <div class="clr-col-10">
                          <app-comment-feature-card [projectId]=projectId [companyId]=companyId [staffId]=offers.employee_phm [subId]=offerId [commentType]=3></app-comment-feature-card>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="btn-group btn-sm btn-primary">
                    <button class="btn" [routerLink]="['/offer/update', projectId, offerId]">Angebot bearbeiten</button>
                    <button class="btn btn-warning" (click)="deleteOffer(projectId, offerId)" [disabled]="erasable">Angebot löschen</button>
                  </div>

                  <clr-datagrid *ngIf="editPos < 2" [clrDgLoading]="loading2" [(clrDgSelected)]="selected" [clrDgRowSelection]="true">
                    <clr-dg-action-bar *ngIf="((editPos < 2) && (statusText === 'Entwurf'))">
                      <div class="btn-group">
                        <button type="button" class="btn btn-sm btn-danger-outline" (click)="onDelete()" ><cds-icon shape="minus-circle"></cds-icon> Positionen löschen</button>
                      </div>
                    </clr-dg-action-bar>
                    <clr-dg-column>Position</clr-dg-column>
                    <clr-dg-column [clrDgField]="'for_pdf'">PDF</clr-dg-column>
                    <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
                    <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
                    <clr-dg-column>Material</clr-dg-column>
                    <clr-dg-column>Kennzeichnung</clr-dg-column>
                    <clr-dg-column [clrDgField]="'specification'">Spezifikation</clr-dg-column>
                    <clr-dg-column>Bemerkungen</clr-dg-column>
                    <clr-dg-column>Anzahl</clr-dg-column>
                    <clr-dg-column>Angebot</clr-dg-column>
                    <clr-dg-column *ngIf="editPos > 0"></clr-dg-column>
                    <clr-dg-placeholder>We couldn't find any Position for Offer {{ projectId }}.0003.{{ offerId }}!</clr-dg-placeholder>
                    <clr-dg-row *clrDgItems="let position of positions; index as i" [clrDgItem]="position">
                      <clr-dg-cell>{{ position.position }}<span *ngIf="position.part != null && position.part > 0">.{{ position.part }}</span> </clr-dg-cell>
                      <clr-dg-cell>
                        <span  *ngIf="position.for_pdf"><cds-icon shape="file" (click)="setVisibility(position.position, position.part ?? 0, false)"></cds-icon></span>
                        <span  *ngIf="!position.for_pdf"><cds-icon shape="eye-hide" (click)="setVisibility(position.position, position.part ?? 0, true)"></cds-icon></span>
                      </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">
                        <b>{{ position.name }}</b>
                        <clr-tooltip *ngIf="position.comment_phm">
                          <cds-icon clrTooltipTrigger role="img" shape="info-circle" size="24" aria-label="PHM comment tooltip"></cds-icon>
                          <clr-tooltip-content clrPosition="bottom-right" clrSize="md" *clrIfOpen>
                            <span>{{ position.comment_phm }}</span>
                          </clr-tooltip-content>
                        </clr-tooltip>
                        <span *ngIf="position.description"><br />{{ position.description }}</span>
                        <span *ngIf="position.taric && position.taric !== '0'"><br />(Zolltarifnummer: {{ position.taric }})</span>
                      </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">{{ position.technical_drawing }}</clr-dg-cell>
                      <clr-dg-cell>
                        {{ position.material }}
                        <span class="small" *ngIf="position.heat_nr !== 'null'"><br *ngIf="position.controlling_nr !== 'null'" /><br *ngIf="position.controlling_nr !== 'null'" />{{ position.heat_nr }}</span>
                        <span class="small" *ngIf="position.controlling_nr !== 'null'"><br *ngIf="((!position.heat_nr) || (position.heat_nr === 'null') || (position.heat_nr === ''))" /><br />{{ position.controlling_nr }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell><span *ngIf="position.serial_nr !== 'null'">{{ position.serial_nr }}</span> </clr-dg-cell>
                      <clr-dg-cell>
                        <span *ngIf="position.specification">{{ position.specification }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell>
                        <span *ngIf="position.remarks"><b>Leistungsumfang:</b> {{ position.remarks }}<br *ngIf="position.side_agreements" /><br *ngIf="position.side_agreements" /></span>
                        <span *ngIf="position.side_agreements"><b>Nebenabreden (Kunde):</b> {{ position.side_agreements }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell class="center">{{ position.number_of_pieces }}</clr-dg-cell>
                      <clr-dg-cell class="right currency"><b>{{ position.selling_price | currency: 'EUR':'code':'1.2-2':'de' }}</b><br />(EK: {{ position.purchasing_price | currency: 'EUR':'code':'1.2-2':'de' }})</clr-dg-cell>
                      <clr-dg-cell class="btn-group btn-primary btn-icon" minlength="300px" *ngIf="editPos > 0">
                        <button class="btn btn-sm" (click)="updatePositionMode(i, position.position, position.part ?? 0)">
                          <cds-icon shape="pencil"></cds-icon>
                          <span class="clr-icon-title">Ändern</span>
                        </button>
                      </clr-dg-cell>
                      <clr-dg-row-detail *clrIfExpanded clrLoading>
                        <table>
                          <app-job-details-requests [jobid]="0" [reqprid]="projectId" [reqposid]="position.position.toString()" [reqpartid]="position.part ?? 0"></app-job-details-requests>
                        </table>
                      </clr-dg-row-detail>
                    </clr-dg-row>
                    <clr-dg-footer *ngIf="!!positions">
                      <clr-dg-pagination #pagination [clrDgPageSize]="50">
                        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Positionen pro Seite</clr-dg-page-size>
                        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
                        von {{positions.length}} Position(en)
                      </clr-dg-pagination>
                    </clr-dg-footer>
                  </clr-datagrid>

                  <app-offer-edit-position [projectNumber]="projectId" [offerNumber]="offerId" [editPosition]="positionId" [editPart]="partId" *ngIf="editPos === 2" (updatedPosition)="updateOffer($event)"></app-offer-edit-position>

                  <br *ngIf="(editPos === 1)"  />

                  <clr-dropdown *ngIf="((editPos === 1) && (statusText === 'Entwurf'))" [clrCloseMenuOnItemClick]="false">
                    <button clrDropdownTrigger class="dropdown-toggle btn btn-link" aria-label="Dropdown positions button">
                      Projektposition hinzufügen
                      <cds-icon shape="angle" direction="down" size="'sm'"></cds-icon>
                    </button>
                    <clr-dropdown-menu *clrIfOpen>
                      <div clrDropdownItem *ngFor="let components of foundPositions" (click)="addRow(components.position, components.positions_part ?? 0, components.technical_drawing, components.name)">{{ components.position }}.{{ components.positions_part }}  {{ components.name }} ({{ components.technical_drawing }})</div>
                    </clr-dropdown-menu>
                  </clr-dropdown>

                  <br *ngIf="(editPos === 1)"  /><br />
                  <div class="btn-group btn-sm btn-primary">
                    <button *ngIf="editPos === 0" class="btn" (click)="basic = true; createOffer(positions)">PDF anzeigen</button>
                    <button *ngIf="editPos === 0" class="btn" (click)="editPos = 1;">Positionen bearbeiten</button>
                    <button *ngIf="editPos > 0" class="btn" (click)="editPos = 0;">Bearbeitung beenden</button>
                    <button *ngIf="editPos === 0" class="btn btn-success-outline" (click)="duplicateOffer(projectId, offerId)">Angebot kopieren</button>
                    <button *ngIf="((editPos === 0) && offers.order_id) " class="btn btn-success" (click)="createJob(projectId, offerId)">Job erstellen</button>
                    <button *ngIf="((editPos === 0) && !offers.order_id)" class="btn" disabled>Job erstellen</button>
                  </div>
                </clr-tab-content>
              </clr-tab>

              <clr-tab>
                <button clrTabLink>Dokumente</button>
                <clr-tab-content clrTabContentId="content2" *clrIfActive>
                  <app-offer-details-documents [offerNumber]="offerId"></app-offer-details-documents>
                </clr-tab-content>
              </clr-tab>
            </clr-tabs>
          </div>
        </div>
        <div class="card-footer">
          <small>Projektverantwortlich:  {{ staffFirstName }} {{ staffLastName }} ({{ offers.employee_phm }})</small>
        </div>
      </div>
    </div>
  </div>
</main>

<clr-modal [(clrModalOpen)]="basic" [clrModalSize]="'xl'">
  <h3 class="modal-title">ANGEBOT {{ projectId }}.0003.{{ offerId }}</h3>
  <div id="documentContainer" class="modal-body"></div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="basic = false">Zurück</button>
    <button type=“button” class="btn btn-primary" (click)="downloadPdf(); basic = false">Download</button>
    <button type="button" class="btn btn-primary" (click)="archivePdf(); basic = false">Archivieren</button>
    <button type="button" class="btn btn-primary" (click)="printPdf(); basic = false">Drucken</button>
  </div>
</clr-modal>

<pre *ngIf="devMode" class="datepicker-output">
{{ selected | json }}
</pre>
